// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visible_Q4k3m {
  display: block;
  /* opacity: 1; */
}

.invisible_GaubT {
  display: none !important;
  /* opacity: 0; */
}

.toolbarWrapper_cad9m {
  display: flex;
  overflow: hidden;
  flex-wrap: nowrap !important;
  position: relative;
}

.tag_tUeOM {
  display: flex;
  flex: 0 0 auto;
}

.container_L_ylJ {
  display: flex;
}

.measurer_zvCJG {
  position: absolute;
  top: 0;
  left: 0;
  flex-wrap: nowrap !important;
  overflow: hidden;
  z-index: -1;
}

.measurer_zvCJG, .toolbarWrapper_cad9m {
  width: 100% !important;
  justify-content: inherit !important;
}

.measurer_zvCJG > * {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/IntersectionObserverWrapper.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".visible {\n  display: block;\n  /* opacity: 1; */\n}\n\n.invisible {\n  display: none !important;\n  /* opacity: 0; */\n}\n\n.toolbarWrapper {\n  display: flex;\n  overflow: hidden;\n  flex-wrap: nowrap !important;\n  position: relative;\n}\n\n.tag {\n  display: flex;\n  flex: 0 0 auto;\n}\n\n.container {\n  display: flex;\n}\n\n.measurer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  flex-wrap: nowrap !important;\n  overflow: hidden;\n  z-index: -1;\n}\n\n.measurer, .toolbarWrapper {\n  width: 100% !important;\n  justify-content: inherit !important;\n}\n\n.measurer > * {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visible": `visible_Q4k3m`,
	"invisible": `invisible_GaubT`,
	"toolbarWrapper": `toolbarWrapper_cad9m`,
	"tag": `tag_tUeOM`,
	"container": `container_L_ylJ`,
	"measurer": `measurer_zvCJG`
};
export default ___CSS_LOADER_EXPORT___;
